import styled from '@emotion/styled';
import { Colors } from '../../../core/theme/Colors';

export const PublicPageCardFormError = styled.div`
    width: 100%;
    margin: 8px;
    color: ${Colors.RedDark};
`;
